import removeMd from 'remove-markdown'

export default function stripMarkdown(text) {
  return JSON.stringify(removeMd(text))
}
